export { default } from "./getEventPropertiesContentType";
